import { CompanyUserDetailScope } from 'mormaii-web-presentation/company-user-detail'
import type { ViewFactory } from 'wdc-cube-solid'

import { CompanyUserDetailView } from './v-company-user-detail'

export function registerViews(rv: typeof ViewFactory.register) {
    rv(CompanyUserDetailScope, CompanyUserDetailView)
}

export { CompanyUserDetailView }
